import type { DriverEntity } from '@/features/driver/domain/entities/DriverEntity'
import type { RegionEntity } from '@/features/region/domain/entities/RegionEntity'
import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'

export class DriverBlockFilterEntity {
  driver?: DriverEntity
  blockedByUser?: UserMiniEntity
  blockDate?: Date[]
  unBlockDate?: Date[]
  region?: RegionEntity
  page?: number
  limit?: number
  sortField?: string
  sortDescending?: boolean 
  fromBlockedAt?: string 
  toBlockedAt?: string 
  fromUnblockedAt?: string 
  toUnblockedAt?: string 
  createdAtFrom?: string 
  createdAtTo?: string 

}
